import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import SEO from '../../components/SEO';
import './styles.css';

export default function EmailChangeApproved() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  return (
    <div className="email-change-page">
      <SEO
        title="Email Change Approved | EternaVaults"
        description="Your email address has been successfully updated."
      />
      <div className="email-change-container">
        <div className="email-change-card">
          <div className="success-icon">
            <CheckCircle size={64} />
          </div>
          <h1>Email Change Approved</h1>
          <p className="email-change-message">
            Your email address has been successfully updated.
          </p>
          {email && (
            <div className="email-display">
              <p>All future notifications will be sent to:</p>
              <p className="email-address">{email}</p>
            </div>
          )}
          <div className="email-change-actions">
            <Link to="/dashboard" className="btn-primary">
              Return to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}


